export default "__VITE_ASSET__62c52838__"